"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var FinanceBreakdownSummaryBlockContainer_1 = require("./summaryBlocks/FinanceBreakdownSummaryBlockContainer");
var useSummaryContext_1 = require("../../react/useSummaryContext");
var Loader_1 = require("../../../../../common/components/presentation/Loader/Loader");
var errorHandler_1 = require("../../../../../common/service/errorHandler");
var PaymentRates_1 = require("../payment/PaymentRates");
var usePlatformConfig_1 = require("../../../../../common/react/usePlatformConfig");
var financeSummaryStyles_1 = require("./financeSummaryStyles");
var FinanceSummaryWidget_1 = require("../../../../common/components/FinanceSummaryWidget");
var FinanceSummaryBreakdownWidget_1 = require("./financeBreakdownBlocks/FinanceSummaryBreakdownWidget");
var shouldHideBreakdownContainer = function (finance, isFinanceV4) {
    var _a, _b, _c, _d, _e, _f, _g;
    if (isFinanceV4) {
        var breakdownBlocks = (finance || {}).breakdownBlocks;
        return !breakdownBlocks || !((_a = breakdownBlocks) === null || _a === void 0 ? void 0 : _a.length);
    }
    else {
        var schema = (_c = (_b = finance) === null || _b === void 0 ? void 0 : _b.breakdown) === null || _c === void 0 ? void 0 : _c.schema;
        if (schema) {
            var data = JSON.parse(schema);
            var breakdown = (((_d = data.schema) === null || _d === void 0 ? void 0 : _d.properties) || {}).breakdown;
            var content = (_f = (_e = breakdown) === null || _e === void 0 ? void 0 : _e.title) === null || _f === void 0 ? void 0 : _f.json;
            return ((_g = content) === null || _g === void 0 ? void 0 : _g.length) === 0;
        }
        else {
            return true;
        }
    }
};
var FinanceSummary = function (_a) {
    var fcConfig = _a.fcConfig, prices = _a.prices, language = _a.language, finance = _a.finance, isMultiCurrency = _a.isMultiCurrency, financeSimulation = _a.financeSimulation, taxLabel = _a.taxLabel;
    var style = financeSummaryStyles_1.default();
    var dimensions = useSummaryContext_1.default().dimensions;
    var _b = react_1.useState(false), isLoading = _b[0], setLoadingStatus = _b[1];
    var _c = usePlatformConfig_1.default().platformConfig, showFinanceBlock = _c.platformFeatures.showComparisonRateOnConfirmation, financeVersion = _c.financeVersion;
    var isFinanceV4 = financeVersion === 4;
    var hideBreakdownContainer = shouldHideBreakdownContainer(finance, isFinanceV4);
    return (<core_1.Box className={style.container} data-test="summary:container:finance_summary">
      {showFinanceBlock ? (<PaymentRates_1.default financeSimulation={financeSimulation}/>) : (<FinanceBreakdownSummaryBlockContainer_1.default isMultiCurrency={isMultiCurrency} prices={prices} finance={finance} taxLabel={taxLabel}/>)}
      {!hideBreakdownContainer && (<>
          {isLoading && <Loader_1.default />}
          {isFinanceV4 ? (<FinanceSummaryBreakdownWidget_1.default finance={finance}/>) : (<FinanceSummaryWidget_1.default language={language} dimensions={dimensions} financeInstanceId={fcConfig.instanceId} financeCurrency={fcConfig.currency} financeWidgetUrl={fcConfig.widgetUrl} financeWidgetPath={fcConfig.paths.widgetPath} financeWidgetChunkPath={fcConfig.paths.chunkPath} financeBackendUrl={fcConfig.backendUrl} breakdown={finance.breakdown.schema} setLoadingStatus={setLoadingStatus} handleErrors={errorHandler_1.default.handleError}/>)}
        </>)}
    </core_1.Box>);
};
exports.default = FinanceSummary;
